var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.20882 7.71208L3.35553 12.5661L8.20882 17.418C8.75093 17.9608 8.75093 18.8414 8.20882 19.3835C7.93637 19.6559 7.58261 19.7907 7.22607 19.7907C6.86952 19.7907 6.51576 19.6559 6.24332 19.3835L0.407279 13.5481C0.146648 13.2882 0 12.9344 0 12.5661C0 12.1984 0.146648 11.8439 0.407279 11.5833L6.24332 5.74658C6.78612 5.20447 7.66601 5.20447 8.20882 5.74658C8.75093 6.28939 8.75093 7.16789 8.20882 7.71208ZM23.9412 11.5826L18.1058 5.74589C17.563 5.20378 16.6831 5.20378 16.1403 5.74589C15.5975 6.28869 15.5975 7.16858 16.1403 7.71139L20.9929 12.5654L16.1403 17.418C15.5975 17.9608 15.5975 18.8414 16.1403 19.3835C16.4128 19.6559 16.7672 19.7907 17.1231 19.7907C17.4789 19.7907 17.8341 19.6559 18.1058 19.3835L23.9412 13.5481C24.2018 13.2875 24.3484 12.9337 24.3484 12.5654C24.3484 12.1984 24.2018 11.8433 23.9412 11.5826ZM14.6036 3.05271C13.8558 2.86019 13.1017 3.31195 12.9113 4.05422L8.7412 20.3857C8.55216 21.1293 9.00044 21.8869 9.74341 22.0773C9.85948 22.1072 9.97554 22.1211 10.0888 22.1211C10.7102 22.1211 11.2745 21.702 11.4351 21.0751L15.6052 4.74368C15.7956 3.99932 15.3466 3.24244 14.6036 3.05271Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.3484,
    height: 24.3484,
    transform: "translate(0 0.390137)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.2b24ca90c11e42c134379af2b43bc5cb.svg";
export { ForwardRef as ReactComponent };